import { render, staticRenderFns } from "./World.vue?vue&type=template&id=380b6d8c&scoped=true"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"
import style0 from "./World.vue?vue&type=style&index=0&id=380b6d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380b6d8c",
  null
  
)

export default component.exports